package com.exura.pages.planCreator.components.seriesViews.inputs

enum class PlanCreatorInputMode {
    EDIT,
    VIEW
}
